const tr = {
  chats:{
    attributes:{
      id: 'ID',
      subject: 'Assunto',
      specialty: 'Especialidade Médica',
      user_from: 'Remetente',
      user_to: 'Destino',
      user_to_id: 'Destino',
      created_at: 'Criado em',
      updated_at: 'Atualizado em',
    },
    extras:{
      openChats: 'Chats em aberto',
      closedChats: 'Chats finalizados',
      close: 'Finalizar',
      start_chat: 'Início do chat',
      end_chat: 'Fim do chat',
      load_more: 'Carregar mais',
      create: 'Novo chat',
      edit: 'Editando chat',
      show: 'Visualizando chat',
      close_confirm: 'Realmente deseja finalizar este chat?',
      close_success: 'Chat encerrado com sucesso!',
      close_fail: 'Não foi possível finalizar o chat!',
    },
    defSingular: 'Chat',
    defPlural: 'Chats',
  }
};

export default tr;
